import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/girl11_l.png'


const _withScopeId = n => (_pushScopeId("data-v-eb210428"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "GroundWork" }
const _hoisted_2 = { id: "section1" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ProgressFld\" data-v-eb210428><div class=\"progBar\" data-v-eb210428><p class=\"bar\" data-v-eb210428></p></div></div><div class=\"MsgFld\" data-v-eb210428><div class=\"MsgText\" data-v-eb210428>プロフィール登録完了</div></div><div class=\"ImgFld\" data-v-eb210428><img src=\"" + _imports_0 + "\" data-v-eb210428></div><div class=\"LastMsg\" data-v-eb210428><div class=\"LastMsgText\" data-v-eb210428>登録いただいたプロフィールを元に、<br data-v-eb210428>専任のチャットオペレーターがあなた<br data-v-eb210428>のお仕事探しをお手伝いします。</div></div>", 4)
const _hoisted_7 = { class: "NextBtnFld" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          class: "Nextbtn",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.JumpLine && _ctx.JumpLine(...args)))
        }, "チャットで相談")
      ])
    ])
  ]))
}